<div id="container" [class.no-wrap]="noWrap">
  <div id="fieldZone" [style]="fieldsStyle">
    <ng-content>

    </ng-content>
  </div>
</div>
